import axios from "axios";
import { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Detail() {
    const [selected, setSelected] = useState<string | null>(null);
    const [data, setData] = useState<any[]>([]);


    const getAllDataGallery = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/gallery?limit=1000`);
            console.log('here', response.data);
            setData(response.data.data.data);
        } catch (error) {
            console.error("Error fetching gallery data:", error);
        }
    }

    useEffect(() => {
        getAllDataGallery();
    }, []);


    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-20 px-5 lg:px-16">
            <div className="flex flex-col items-start gap-4 mb-12 border-b border-bprDarkBlue">
                <h1 className="text-2xl md:text-3xl font-bold">
                    Galeri BPR Palu Anugerah
                </h1>
                <p className="text-gray-600 mb-12">
                    Jelajahi momen-momen berharga dan kegiatan seru di BPR Palu Anugerah melalui galeri foto kami. Dari acara komunitas hingga kegiatan sosial, temukan kisah di balik setiap gambar yang kami bagikan.
                </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[180px]">

                {data.map((data, i) => {
                    const isBig = i % 5 === 0;
                    const isWide = i % 7 === 0;

                    return (
                        <div
                            key={i}
                            onClick={() => setSelected(`${process.env.REACT_APP_API_ENDPOINT}/gallery/getimg/${data.img}`)}
                            className={`
                                relative overflow-hidden rounded-2xl cursor-pointer group
                                ${isBig ? "md:col-span-2 md:row-span-2" : ""}
                                ${isWide ? "col-span-2 md:col-span-2" : ""}
                            `}
                        >
                            <LazyLoadImage
                                src={`${process.env.REACT_APP_API_ENDPOINT}/gallery/getimg/${data.img}`}
                                alt="gallery"
                                effect="blur"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                wrapperProps={{
                                    style: { transitionDelay: '1s' },
                                }}
                            />

                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition" />

                            <div className="absolute bottom-3 left-3 text-white opacity-0 group-hover:opacity-100 transition text-sm font-medium">
                                Lihat
                            </div>
                        </div>
                    );
                })}
            </div>

            {selected && (
                <div
                    className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
                    onClick={() => setSelected(null)}
                >
                    <LazyLoadImage
                        src={selected}
                        alt="preview"
                        className="max-h-[90vh] rounded-xl shadow-2xl"
                    />
                </div>
            )}
        </div>
    );
}